module.exports = __webpack_public_path__ + "static/archmage-b92b014051b503aab9847a5466f5ebe7.jpg";